module.exports = __webpack_public_path__ + "static/media/display17.747816e4.jpg";